import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCbscWSt7KXJNvYEEtT1lICtImNVNvW5BQ",
  authDomain: "mercado-intimo.firebaseapp.com",
  projectId: "mercado-intimo",
  storageBucket: "mercado-intimo.firebasestorage.app",
  messagingSenderId: "618873145562",
  appId: "1:618873145562:web:93060803de3d42e1c8bde3",
  measurementId: "G-WGZLNJJ6CZ"
};

// Inicializa Firebase
let app;
let auth;
let googleProvider;

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
} catch (error) {
    console.warn("Firebase não inicializado:", error);
}

export { auth, googleProvider };
